import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from 'src/app/shared/services/base.service';
import { BaseResponse } from 'src/app/shared/models/base-response.model';
import {
    ChangePasswordAccountDto,
    DeviceTokenDto,
    NotificationDto,
    Profile,
    ResetPasswordAccountDto,
} from './models';
import { Pagination } from 'src/app/shared/models/pagination.model';

@Injectable({ providedIn: 'root' })
export class AccountService extends BaseService {
    private _sharedHeaders = new HttpHeaders();
    constructor(private http: HttpClient) {
        super();
        this._sharedHeaders = this._sharedHeaders.set(
            'Content-Type',
            'application/json'
        );
    }

    getProfile() {
        return this.http
            .get<BaseResponse<Profile>>(
                `${environment.apis.default.url}/admin/profile`,
                { headers: this._sharedHeaders }
            )
            .pipe(catchError(this.handleError));
    }

    changePassword(input: ChangePasswordAccountDto) {
        return this.http
            .post(
                `${environment.apis.default.url}/admin/change-password`,
                JSON.stringify(input),
                { headers: this._sharedHeaders }
            )
            .pipe(catchError(this.handleError));
    }

    resetPassword(input: ResetPasswordAccountDto) {
        return this.http
            .post(
                `${environment.apis.default.url}/admin/reset-password`,
                JSON.stringify(input),
                { headers: this._sharedHeaders }
            )
            .pipe(catchError(this.handleError));
    }

    putDeviceToken(input: DeviceTokenDto) {
        return this.http
            .put(
                `${environment.apis.default.url}/admin/device-token`,
                JSON.stringify(input),
                { headers: this._sharedHeaders }
            )
            .pipe(catchError(this.handleError));
    }

    getNotification(page: number, per_page: number) {
        return this.http
            .get<Pagination<NotificationDto>>(
                `${environment.apis.default.url}/admin/notification?page=${page}&per_page=${per_page}`,
                { headers: this._sharedHeaders }
            )
            .pipe(
                map((response: Pagination<NotificationDto>) => {
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    makeReadAllNotification() {
        return this.http
        .post<any>(
            `${environment.apis.default.url}/admin/notification/mark_read_all`,
            { headers: this._sharedHeaders }
        )
        .pipe(catchError(this.handleError));
    }

    makeReadNotification(id: number) {
        return this.http
        .get<any>(
            `${environment.apis.default.url}/admin/notification/${id}`,
            { headers: this._sharedHeaders }
        )
        .pipe(catchError(this.handleError));
    }
}
